// extracted by mini-css-extract-plugin
export var container = "_57-0";
export var disabled = "_57-4";
export var fullWidth = "_57-3";
export var lined = "_57-1";
export var selected = "_57-5";
export var tab = "_57-2";